import {
  Button,
  IconButton,
  Spacer,
  SvgRecord,
  SvgVideoCam,
  TextButton,
} from '@loomhq/lens';
import { isSupported } from '@loomhq/loom-sdk';
import React, { Suspense } from 'react';
import { useSelector } from 'react-redux';

import { EXP_RECORD_REPLY_LOGGED_IN_USERS } from 'constants/featureFlag';

import { selectUserIsLogged } from 'selectors/user';
import { selectRecordReplyEnabled } from 'selectors/video';

import FeatureFlaggedComponent from 'components/feature-flag-wrapper';

const TextIconButton = props => {
  const { compact } = props;

  return compact ? (
    <IconButton isDisabled icon={<SvgVideoCam />} />
  ) : (
    <TextButton isDisabled icon={<SvgVideoCam />}>
      Record a Reply
    </TextButton>
  );
};

export const RecordReplyWrapper = props => {
  const isLoggedIn = useSelector(selectUserIsLogged);
  const recordReplyEnabled = useSelector(selectRecordReplyEnabled);

  if (isLoggedIn && recordReplyEnabled && isSupported()) {
    return (
      <FeatureFlaggedComponent
        flag={EXP_RECORD_REPLY_LOGGED_IN_USERS}
        activationValues={['variant']}
      >
        <Spacer left="large" />
        <RecordReplyFallbackButton {...props} />
      </FeatureFlaggedComponent>
    );
  }

  return null;
};

const RecordReplyFallbackButton = props => {
  const LazyRecordAReply = React.lazy(() => import('./record-reply'));

  const { iconButton, compact } = props;

  return (
    <Suspense
      fallback={
        // Render a fake button as a fallback
        iconButton ? (
          <TextIconButton compact={compact} />
        ) : (
          <div className="bgc:white radius:medium">
            <Button
              variant="neutral"
              icon={<SvgRecord color="#ff623e" />}
              isDisabled
            >
              Record a Reply
            </Button>
          </div>
        )
      }
    >
      <LazyRecordAReply iconButton={iconButton} compact={compact} />
    </Suspense>
  );
};

export default RecordReplyFallbackButton;
